import { APP_NAME } from '@screenshare/shared';

export function Brand() {
  return (
    <a class="brand" href="/" aria-label={`${APP_NAME} home`}>
      <span class="brand-mark" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <rect x="3.5" y="4" width="17" height="12" rx="2.5" />
          <path d="M9 20h6M12 16v4" />
        </svg>
      </span>
      <span>{APP_NAME}</span>
    </a>
  );
}

export function PrivacyMark() {
  return (
    <span class="privacy-mark">
      <span class="privacy-dot" aria-hidden="true" />
      Private · peer to peer
    </span>
  );
}
